import { render, staticRenderFns } from "./OpenApiPopup.vue?vue&type=template&id=3a4872aa"
import script from "./OpenApiPopup.vue?vue&type=script&lang=js"
export * from "./OpenApiPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports